export default class Contact {
  phoneNumber?: string;
  email: string;
}
